import assetPath from '/app/packages/lebenslauf/articles/src/assets/sprachkenntnisse-lebenslauf.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')